// extracted by mini-css-extract-plugin
module.exports = {"container":"Admin_container__1GKkD","body":"Admin_body__Xtdrt","scrollContent":"Admin_scrollContent__kcdfc"};